import React from 'react';
import {
  Check,
  X,
  Loader2,
} from 'lucide-react';

// Color badge for the final STIR/SHAKEN attestation level.
/**
 * @param {{ level: string }} props - Final STIR/SHAKEN attestation level.
 */
export function ShakenBadge({ level }) {
  const map = {
    A: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/40',
    B: 'bg-amber-500/15 text-amber-300 border-amber-500/40',
    C: 'bg-rose-500/15 text-rose-300 border-rose-500/40',
    unregistered: 'bg-white/10 text-white/50 border-white/20',
    unknown: 'bg-white/10 text-white/50 border-white/20',
  };
  const cls = map[level] || map.unknown;
  return (
    <span className={`px-2 py-0.5 rounded-md border text-xs font-mono ${cls}`}>
      SHAKEN {level === 'A' || level === 'B' || level === 'C' ? level : (level || 'unknown')}
    </span>
  );
}

// One row in the trust-chain progress panel.
/**
 * @param {{ label: string, state: 'pending'|'done'|'failed' }} props
 */
export function TrustRow({ label, state }) {
  // state: 'pending' | 'done' | 'failed'
  let icon;
  if (state === 'done') icon = <Check className="w-4 h-4 text-emerald-400" />;
  else if (state === 'failed') icon = <X className="w-4 h-4 text-rose-400" />;
  else icon = <Loader2 className="w-4 h-4 text-white/50 animate-spin" />;
  return (
    <li className="flex items-center justify-between gap-3 py-2 border-b border-civix-border/30 last:border-0">
      <span className="text-sm text-white/80">{label}</span>
      <span className="w-5 h-5 inline-flex items-center justify-center">{icon}</span>
    </li>
  );
}

export const REPUTATION_ROWS = [
  { key: 'numeracle', label: 'Register with Numeracle' },
  { key: 'free_caller_registry', label: 'Submit to Free Caller Registry' },
  { key: 'first_orion', label: 'Submit to First Orion' },
  { key: 'tns', label: 'Submit to TNS' },
];

/**
 * Maps a reputation-provider status onto a TrustRow state.
 * @param {string} status
 * @returns {'pending'|'done'|'failed'}
 */
export function repState(status) {
  if (status === 'clean' || status === 'ok' || status === 'unknown') return 'done';
  if (status === 'error' || status === 'fail') return 'failed';
  return 'pending';
}
